<template>
  <div>
    <div class="avatar-list" :class="centered ? 'tgbAvatarList--centered' : ''" data-test="producer-avatar-list">
      <transition-group
        name="slide-fade"
        class="avatar__wrapper"
        tag="div"
        @leave="leave"
        @after-leave="afterLeave"
      >
        <tgb-avatar
          v-for="user in filteredUsers"
          :key="user.id"
          :displayName="user.displayName"
          :profileImageUrl="user.profileImageUrl"
          :borderColor="randomColor()"
          :data-test="`producer-avatar-${user.id}`"
        />
      </transition-group>

      <div
        v-if="isOverLimit"
        class="avatar-list__overflow"
      >
        +{{ userIds.length - max }}
      </div>
    </div>

    <slot
      v-if="!isTransitioning && (!filteredUsers || !filteredUsers.length)"
      name="noUsers"
      tag="div"
    >
      <div>There are currently no users working in this production.</div>
    </slot>
  </div>
</template>

<script>
import tgbAvatar from './tgbAvatar.vue';

import randomColor from '../../../js/utils/random-color';

export default {
  name: 'TgbAvatarList',
  components: {
    tgbAvatar,
  },

  props: {
    users: {
      type: Array,
      default: () => [],
    },

    centered: {
      type: Boolean,
      default: false,
    },

    max: {
      type: Number,
      default: 6,
    },
  },

  data() {
    return {
      isTransitioning: false,
    };
  },

  methods: {
    randomColor,

    leave() {
      // Using the transition callbacks to track animation
      // so we don't preemptively show the empty state message
      this.isTransitioning = true;
    },

    afterLeave() {
      this.isTransitioning = false;
    },
  },

  computed: {
    userIds() {
      return [...this.users.reduce((memo, user) => memo.add(user.id), new Set())];
    },

    /**
    * De-dupe and splice list of users to only get 6 (default)
    * @returns {Array<Object>} List of users
    */
    filteredUsers() {
      return this.userIds
        .map((id) => this.users.find((u) => u.id === id))
        .slice(0, this.max);
    },

    /**
    * Whether or not there's more users than we can realistically show
    * @returns {Boolean}
    */
    isOverLimit() {
      return this.userIds.length > this.max;
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-list {
  display: flex;
  align-items: center;

  &--centered .avatar__wrapper {
    margin: auto;
  }

  .avatar__wrapper {
    display: flex;
    align-items: center;
  }
}

.avatar-list__overflow {
  margin-left: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid;
  font-weight: 500;
  text-align: center;
  background: #252525;
  z-index: 1;
}
</style>
